<template>
  <div
    v-if="supplier"
    id="resort-checklist"
    class="box box-extended is-green p-6"
  >
    <h4 class="font-medium fs-20">Resort checklist</h4>

    <div v-if="supplier.number_of_rooms" class="mt-4">
      <span class="text-black-light-5">Number of rooms:</span>
      <span class="ml-2">
        {{ supplier.number_of_rooms }}
      </span>
    </div>

    <div v-if="supplier.is_adult_only" class="mt-4">
      <span class="text-black-light-5">Adults only:</span>
      <span class="ml-2">
        {{ supplier.is_adult_only ? "Yes" : "No" }}
      </span>
    </div>

    <div v-if="supplier.has_overwater_bungalows" class="mt-4">
      <span class="text-black-light-5">Overwater bungalows:</span>
      <span class="ml-2">
        {{ supplier.has_overwater_bungalows ? "Yes" : "No" }}
      </span>
    </div>

    <div v-if="supplier.number_of_restaurants" class="mt-4">
      <span class="text-black-light-5">Restaurants and bars:</span>
      <span class="ml-2">
        {{ supplier.number_of_restaurants }}
      </span>
    </div>

    <div v-if="supplier.meal_plans.length" class="standard-list">
      <p class="text-black-light-5 mt-4">Meal plans:</p>
      <ul class="mt-1">
        <li v-for="meal in supplier.meal_plans" :key="meal">
          {{ translateMealPlans(meal) }}
        </li>
      </ul>
    </div>

    <div v-if="supplier.dive_center_rating" class="mt-4">
      <span class="text-black-light-5">Official dive center rating:</span>
      <span class="ml-1">{{ supplier.dive_center_rating }}</span>
    </div>

    <div v-if="supplier.has_house_reef" class="mt-4">
      <span class="text-black-light-5">House reef:</span>
      <span class="ml-2">{{ supplier.has_house_reef ? "Yes" : "No" }}</span>
    </div>

    <div v-if="supplier.has_nitrox" class="mt-4">
      <span class="text-black-light-5">Nitrox:</span>
      <span class="ml-2">{{ supplier.has_nitrox ? "Yes" : "No" }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["resortId"],
  data() {
    return {
      supplier: null,
    };
  },
  mounted() {
    window.fetchSupplierInfo(this.resortId).then((response) => {
      this.supplier = response.supplier;
    });
  },
  methods: {
    translateMealPlans(val) {
      switch (val) {
        case "HB":
          return "Half Board";
        case "BB":
          return "Breakfast";
        case "FB":
          return "Full Board";
        case "AI":
          return "All Inclusive";
        default:
          return "";
      }
    },
  },
};
</script>
